import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { RATINGS } from 'voxloud-types/dist/models/reviews';

@Component({
  selector: 'gdp-select-rating',
  templateUrl: './select-rating.component.html',
  styleUrls: ['./select-rating.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectRatingComponent),
      multi: true
    }
  ]
})
export class SelectRatingComponent implements ControlValueAccessor {
  public RATINGS: number[] = RATINGS;
  public selectedRatings: number = this.RATINGS[0];
  @Input() set selectedRating(rating: number) {
    this.selectedRatings = rating;
  };

  onChange: any = () => { }
  onTouch: any = () => { }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  writeValue(val: number) {
    if (val) {
      this.selectedRatings = val;
    }
  }

  public selectRating(rating: number) {
    this.selectedRatings = rating;
    this.onChange(rating);
  }

}
